import { IMAGINUS_MODEL_PROFILE_STORAGE_KEY } from '../imaginus/imaginus-composer-models.util';
import { IMAGINUS_RESPONSE_MODE_STORAGE_KEY } from './imaginus.service';
import { preserveChatReadKeys } from './chat-read-state.util';

/** 登出後仍保留：裝置層／登入表單偏好（不含帳號專屬的常用、團隊、Imaginus 釘選）。 */
const EXACT_KEYS_TO_PRESERVE = [
  'ima_one_theme',
  IMAGINUS_MODEL_PROFILE_STORAGE_KEY,
  IMAGINUS_RESPONSE_MODE_STORAGE_KEY,
  'ima_desktop_shell',
  'ima_remember_signin',
  'ima_remember_email',
  'ima_locale',
  'ima_locale_source',
];

/** 登出時清除 session，保留裝置層設定；帳號專屬資料由 ApplicationSessionStateService 一併重置。 */
export function clearLocalStorageSession(): void {
  if (typeof localStorage === 'undefined') {
    return;
  }

  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('token');
  }
  localStorage.removeItem('token');
  localStorage.removeItem('ima_token_remember');

  const preserved = new Map<string, string>();

  for (const key of EXACT_KEYS_TO_PRESERVE) {
    const value = localStorage.getItem(key);
    if (value !== null) {
      preserved.set(key, value);
    }
  }

  preserveChatReadKeys(preserved);

  localStorage.clear();

  preserved.forEach((value, key) => {
    localStorage.setItem(key, value);
  });
}
